import * as z from "zod";
import { shopperAgentInsightsAnalytics } from "./shopper-agent-insights-analytics";
import { textConciergeAnalytics } from "./text-concierge-analytics";

/**
 * The Commerce Agent's value for a date range: Text Concierge reach/engagement,
 * shopper-agent sentiment/topics, and indirect attributed revenue.
 */
export const conciergeValueReport = {
  name: "conciergeValueReport" as const,
  input: z.object({ start: z.date(), end: z.date() }),
  output: z.object({
    reach: textConciergeAnalytics.output,
    insights: shopperAgentInsightsAnalytics.output,
    indirectRevenue: z.object({
      attributedRevenue: z.number(),
      attributedOrderCount: z.number(),
      /** ISO currency for the money field, or null when the window mixes currencies or has no data. */
      revenueCurrency: z.string().nullable(),
    }),
  }),
};
